import type { Locale } from '@boty/i18n';

/**
 * Maps each supported locale to the slug of the localized Boty Help Bot.
 * Each bot shares the same documentation content (Boty's AI translates
 * responses on the fly), but has a localized name and welcome message.
 */
const HELP_BOT_SLUGS: Record<Locale, string> = {
  en: 'boty-help',
  he: 'boty-help-he',
  es: 'boty-help-es',
};

/**
 * Get the slug of the Boty Help Bot for the given locale.
 * Falls back to the English bot if the locale is not recognized.
 */
export function getHelpBotSlug(locale: string): string {
  return HELP_BOT_SLUGS[locale as Locale] ?? HELP_BOT_SLUGS.en;
}
